import socket, { invokeRPC } from './socket.js'

export function createCustomer(data) {
  return invokeRPC('customer', 'createCustomer', data)
}

export function getActiveCustomerList() {
  return invokeRPC('customer', 'getActiveCustomerList')
}

export function getInactiveCustomerList() {
  return invokeRPC('customer', 'getInactiveCustomerList')
}

export function deleteCustomer(data) {
  return invokeRPC('customer', 'deleteCustomer', data)
}

export function getCustomer(id) {
  return invokeRPC('customer', 'getCustomer', { id })
}

export function getUserListForCustomer(id) {
  return invokeRPC('customer', 'getUserListForCustomer', { id })
}

export function canAddUser(customerId) {
  return invokeRPC('customer', 'canAddUser', { id: customerId })
}

export function changeActive(id, status) {
  return invokeRPC('customer', 'changeActive', { id, status: !status })
}

export function updateCustomer(data) {
  return invokeRPC('customer', 'updateCustomer', data)
}

export function activeUserCount(id) {
  return invokeRPC('customer', 'activeUserCount', { id })
}

export function setHasTheme(id, hasTheme) {
  return invokeRPC('customer', 'setHasTheme', { customer_id: id, hasTheme })
}

export function hasTheme(id) {
  return invokeRPC('customer', 'hasTheme', { customer_id: id })
}

export function toggleMasterMaintenance(value) {
  return invokeRPC('customer', 'toggleMasterMaintenance', { toggle: value })
}

export function getMaintenanceHistory() {
  return invokeRPC('customer', 'getMaintenanceHistory')
}

export function checkIfMaintenanceOn() {
  return invokeRPC('customer', 'checkIfMaintenanceOn')
}

export function checkMaintenanceByCustomer(id) {
  return invokeRPC('customer', 'checkMaintenanceByCustomer', { customer_id: id })
}

export function emailAllUsers(data) {
  return invokeRPC('customer', 'emailAllUsersForCustomer', data)
}
